// extracted by mini-css-extract-plugin
export var chatHtmlText = "_su-2";
export var chatLink = "_su-0";
export var chatText = "_su-1";